import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $file, $http } from '@/axios';
import { downloadFile } from '@/utils/helper';

// 查询专案组下所有报价单
export const queryDpgQuotations: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDpgQuotations', { ...state.quotations, loading: true });
    const res: any = await $http.get(`/v1/design/dpg/quotation/${payload}/detail`);
    commit('setDpgQuotations', { data: res });
  } catch (e) {
    commit('setDpgQuotations', { data: [] });
  }
};

// 查询报价单详情
export const queryDpgQuotationDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setDpgQuotationDetail', { data: null, loading: true });
    const res: any = await $http.get(`/quotation/detail/${payload}`);
    commit('setDpgQuotationDetail', { data: res });
    return res;
  } catch (e) {
    commit('setDpgQuotations', { data: [] });
    throw e;
  }
};

// 查询报价单详情
export const editDpgQuotation: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await $http.post('/quotation/modify', payload);
    return true;
  } catch (e) {
    throw e;
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 导出报价单
export const exportDpgQuotation: IActionFn<IModuleState> = async ({ dispatch, commit, state }, payload) => {
  const res: any = await dispatch('queryDpgQuotationDetail', payload.id);
  const lineIds = (res.lines || []).map((item: any) => item.id);
  const file: { blob: Blob } = await $file.post('/v1/quotation/export', { id: payload.id, lineIds });
  downloadFile(file.blob, '报价单');
};
